import React from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Text, Box, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "60px 0 60px 0",
    "background": "transparent"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "width": "22%",
            "padding": "30px 20px",
            "align-items": "center",
            "display": "flex",
            "justify-content": "center",
            "flex-direction": "column",
            "lg-width": "45%",
            "sm-width": "100%",
            "margin": "10px"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "font": "normal 800 48px/1.1 --fontFamily-sans",
            "color": "#FD6DF9",
            "text-shadow": "0 0 20px rgba(253, 109, 249, 0.4)",
            "children": "90%"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 0px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.7)",
            "text-align": "center",
            "children": <>
                меньше времени на создание стратегии
                <br/>
            </>
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "width": "22%",
            "padding": "30px 20px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "flex-direction": "column",
            "lg-width": "45%",
            "sm-width": "100%",
            "margin": "10px"
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "font": "normal 800 48px/1.1 --fontFamily-sans",
            "color": "#FD6DF9",
            "text-shadow": "0 0 20px rgba(253, 109, 249, 0.4)",
            "children": "90%"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 0px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.7)",
            "text-align": "center",
            "children": <>
                экономия времени при бэктестировании
                <br/>
            </>
        }
    },
    "box2": {
        "kind": "Box",
        "props": {
            "width": "22%",
            "padding": "30px 20px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "flex-direction": "column",
            "lg-width": "45%",
            "sm-width": "100%",
            "margin": "10px"
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "font": "normal 800 48px/1.1 --fontFamily-sans",
            "color": "#FD6DF9",
            "text-shadow": "0 0 20px rgba(253, 109, 249, 0.4)",
            "children": "80%"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 0px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.7)",
            "text-align": "center",
            "children": "экономьте деньги на создании стратегии"
        }
    },
    "box3": {
        "kind": "Box",
        "props": {
            "width": "22%",
            "padding": "30px 20px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "flex-direction": "column",
            "lg-width": "45%",
            "sm-width": "100%",
            "margin": "10px"
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "font": "normal 800 48px/1.1 --fontFamily-sans",
            "color": "#FD6DF9",
            "text-shadow": "0 0 20px rgba(253, 109, 249, 0.4)",
            "children": "50%"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 0px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.7)",
            "text-align": "center",
            "children": "больше денег, заработанных в ходе торговли"
        }
    }
};

const CdzvStatsRU = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" justify-content="center" align-items="stretch"/>
        <Box {...override("box")} className="glass-card">
            <Text {...override("text")} />
            <Text {...override("text1")} />
        </Box>
        <Box {...override("box1")} className="glass-card">
            <Text {...override("text2")} />
            <Text {...override("text3")} />
        </Box>
        <Box {...override("box2")} className="glass-card">
            <Text {...override("text4")} />
            <Text {...override("text5")} />
        </Box>
        <Box {...override("box3")} className="glass-card">
            <Text {...override("text6")} />
            <Text {...override("text7")} />
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvStatsRU, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvStatsRU;